export default function formatPhoneNumberInput(value: string): string {
  return value.replace(/ /g, '').replace(/-/g, '');
}
